import { makeStyles } from '@material-ui/core';

import { PRIMARY_COLOR_APP, XMEI_PRIMARY_COLOR } from '../../../consts/common';

export const useStyles = makeStyles((theme) => ({
  grid: {
    minHeight: '100vh',
    [theme.breakpoints.up('sm')]: {
      backgroundColor: XMEI_PRIMARY_COLOR,
      paddingLeft: 20,
      paddingRight: 20,
      paddingTop: 30,
      paddingBottom: 30,
    },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  container: {
    flex: 1,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: '50%',
    },
  },
  header: {
    color: PRIMARY_COLOR_APP,
    fontSize: 20,
    fontWeight: '400',
    marginLeft: 10,
    paddingVertical: 20,
    fontFamily: 'Roboto',
  },
  viewCards: {
    flex: 1,
    paddingLeft: 20,
    paddingRight: 20,
    [theme.breakpoints.up('sm')]: {
      paddingLeft: 0,
      paddingRight: 0,
    },
    marginTop: -50,
  },
  viewAbsolute: {
    height: 50,
    width: '100%',
  },
  headerTextStyle: { fontSize: 20 },
}));
